import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AiOutlineMenu, AiOutlineClose } from 'react-icons/ai';
import { showCategories } from '../../services/operations/categoryAPI'; // Adjust the path as needed

const Navbar = () => {
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [categories, setCategories] = useState([]);
  const [menuOpen, setMenuOpen] = useState(false); // For mobile menu toggle

  // Function to fetch categories from the API
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const fetchedCategories = await showCategories();
        if (fetchedCategories && Array.isArray(fetchedCategories)) {
          setCategories(fetchedCategories);
        } else {
          console.error('Unexpected data format:', fetchedCategories);
        }
      } catch (error) {
        console.error('Error fetching categories:', error);
      }
    };

    fetchCategories();
  }, []);

  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };

  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  return (
    <nav className="bg-white shadow-md py-4 mt-2 mb-1">
      <div className="container mx-auto px-4 flex items-center justify-between">
        {/* Left: Logo */}
        <div className="flex items-center space-x-4">
          <Link to="/" className="text-3xl  font-bold text-yellow-200 font-norwester">
            Mehandi Dreams
          </Link>
        </div>

        {/* Center: Navigation Links for Desktop */}
        <div className="hidden md:flex space-x-8">
          <Link to="/" className="text-richblack-600 hover:text-yellow-200">Home</Link>
          <Link to="/aboutus" className="text-richblack-600 hover:text-yellow-200">About me</Link>
          <div className="relative">
            <button className="text-richblack-600 hover:text-yellow-200" onClick={toggleDropdown}>
              Catalog
            </button>
            {dropdownOpen && (
              <div className="absolute top-full -right-[11rem] mt-2 w-[25rem] shadow-[0px_0px_20px_1px_#ed8936] bg-white rounded-lg z-10 transition duration-300 ease-in-out">
                {categories.length > 0 ? (
                  <div className="grid grid-cols-2 gap-2 p-2">
                    {categories.map((category) => (
                      <Link
                        key={category._id}
                        to={`/catalog/${category._id}`}
                        className="block px-4 py-2 text-richblack-600 hover:bg-yellow-200 hover:text-white rounded-lg"
                      >
                        {category.name}
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="px-4 py-2 text-richblack-600">No categories available</div>
                )}
              </div>
            )}
          </div>
          <Link to="/gallery" className="text-richblack-600 hover:text-yellow-200">Gallery</Link>
          <Link to="/contact" className="text-richblack-600 hover:text-yellow-200">Contact</Link>
        </div>

        {/* Right: BOOK MEHANDI Button for Desktop */}
        <div className="hidden md:flex items-center space-x-4">
          <Link to="/contact" className="bg-yellow-200 font-mono text-white px-4 py-2 rounded-lg hover:bg-yellow-700">
            BOOK MEHANDI
          </Link>
        </div>

        {/* Mobile Menu Toggle Button */}
        <div className="md:hidden flex items-center">
          <button onClick={toggleMenu} className="text-3xl text-richblack-600">
            {menuOpen ? <AiOutlineClose /> : <AiOutlineMenu />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {menuOpen && (
        <div className="md:hidden mt-2  bg-richblack-800  text-white shadow-md  transition duration-300 ease-in-out">
          <Link
            to="/"
            className="block px-4 py-2 text-richblack-100 hover:text-yellow-200"
            onClick={() => setMenuOpen(false)}
          >
            Home
          </Link>
          <Link
            to="/aboutus"
            className="block px-4 py-2 text-richblack-100 hover:text-yellow-200"
            onClick={() => setMenuOpen(false)}
          >
            About me
          </Link>
          <div className="relative">
            <button
              className="block w-full px-4 py-2 text-left text-richblack-100 hover:text-yellow-200"
              onClick={toggleDropdown}
            >
              Catalog
            </button>
            {dropdownOpen && (
              <div className="pl-4">
                {categories.length > 0 ? (
                  <div className="grid grid-cols-1 gap-1 p-2">
                    {categories.map((category) => (
                      <Link
                        key={category._id}
                        to={`/catalog/${category._id}`}
                        className="block px-4 py-2 text-richblack-100 hover:bg-yellow-200 hover:text-white rounded-lg"
                        onClick={() => setMenuOpen(false)}
                      >
                        {category.name}
                      </Link>
                    ))}
                  </div>
                ) : (
                  <div className="px-4 py-2 text-richblack-100">No categories available</div>
                )}
              </div>
            )}
          </div>
          <Link
            to="/gallery"
            className="block px-4 py-2 text-richblack-100 hover:text-yellow-200"
            onClick={() => setMenuOpen(false)}
          >
            Gallery
          </Link>
          <Link
            to="/contact"
            className="block px-4 py-2 text-richblack-100 hover:text-yellow-200"
            onClick={() => setMenuOpen(false)}
          >
            Contact
          </Link>
          <Link
            to="/contact"
            className="block bg-yellow-200 text-white px-4 py-2 mt-2 rounded-lg hover:bg-yellow-700"
            onClick={() => setMenuOpen(false)}
          >
            BOOK MEHANDI
          </Link>
        </div>
      )}
    </nav>
  );
};

export default Navbar;
